import React, { useState } from "react";
import { Box, Button, TextField } from "@mui/material";
import ProfileDropdown from "./ProfileDropdown";
import { useLocation, useNavigate } from "react-router-dom";
import RemoveIcon from "../assets/images/remove-icon.png";
import DashboardHeaderMobile from "./DashboardHeaderMobile";
import EchoIcon from "../assets/images/echo-plain.png";
import { useSelector } from "react-redux";
import ConnectButtonModal from "./ConnectButtonModal";
import { SCORM_ENABLED } from "../helpers/scorm/featureFlag";
const TabButton = ({ name, label, activeTab }) => {
  const navigate = useNavigate();
  return (
    <Box
      sx={{
        marginRight: {
          xs: "10px",
          sm: "10px",
          md: "5px",
          lg: "15px",
          xl: "20px",
        },
      }}
    >
      {" "}
      <Button
        onClick={() => {
          navigate(`/dashboard?active=${name}`);
        }}
        sx={{
          background: activeTab === name ? "#2A48761A" : "transparent",
          fontWeight: activeTab === name ? 600 : 400,
          borderRadius: "100px",
          height: {
            xs: "40px",
            sm: "40px",
            md: "45px",
            lg: "50px",
            xl: "60px",
          },
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          textTransform: "capitalize",
          padding: {
            xs: "10px",
            sm: "10px",
            md: "10px",
            lg: "10px 20px",
            xl: "10px 30px",
          },
          color: "#2A4876",
          fontSize: {
            xs: "12px",
            sm: "12px",
            md: "12px",
            lg: "16px",
            xl: "18px",
          },
          lineHeight: "23.29px",
          "&:hover": {
            background: "#2A48761A",
            color: "#2A4876",
            fontWeight: 600,
          },
        }}
      >
        {label}
      </Button>
    </Box>
  );
};

export const NavItems = (role, activeTab) => {
  switch (role) {
    case "mentee":
      return (
        <>
          <TabButton
            name={"myevents"}
            label={"My Events"}
            activeTab={activeTab}
          />
          <TabButton name={"learn"} label={"Learn"} activeTab={activeTab} />
          {SCORM_ENABLED && (
            <TabButton
              name={"training"}
              label={"Training"}
              activeTab={activeTab}
            />
          )}
          <TabButton
            name={"industryhub"}
            label={"Industry Hub"}
            activeTab={activeTab}
          />
        </>
      );
    case "mentor":
      return (
        <>
          <TabButton
            name={"myevents"}
            label={"My Events"}
            activeTab={activeTab}
          />
          <TabButton name={"learn"} label={"Learn"} activeTab={activeTab} />
          {SCORM_ENABLED && (
            <TabButton
              name={"training"}
              label={"Training"}
              activeTab={activeTab}
            />
          )}
          <TabButton
            name={"industryhub"}
            label={"Industry Hub"}
            activeTab={activeTab}
          />
        </>
      );
    case "mentee_mentor":
      return (
        <>
          <TabButton
            name={"myevents"}
            label={"My Events"}
            activeTab={activeTab}
          />
          <TabButton name={"learn"} label={"Learn"} activeTab={activeTab} />
          {SCORM_ENABLED && (
            <TabButton
              name={"training"}
              label={"Training"}
              activeTab={activeTab}
            />
          )}
          <TabButton
            name={"industryhub"}
            label={"Industry Hub"}
            activeTab={activeTab}
          />
        </>
      );
    case "sponsor":
      return (
        <>
          <TabButton
            name={"managecontent"}
            label={"Manage Content"}
            activeTab={activeTab}
          />
          <TabButton
            name={"transactions"}
            label={"Past Purchases"}
            activeTab={activeTab}
          />
        </>
      );
    default:
      break;
  }
};

const getConnectLabel = (role) => {
  switch (role) {
    case "mentee":
      return "Mentors";
    case "mentor":
      return "Mentees";
    case "mentee_mentor":
      return "Connect";
    default:
      return "";
  }
};

const MenteeHeader = (props) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [openModal, setOpenModal] = useState(false);
  //const role = useSelector((state) => state.auth?.loginDetails?.profile?.role)
  const role = localStorage.getItem("role");
  console.log("role is", role);
  const userId = useSelector((state) => state?.profileSlice?.profile?.id);
  const urlParams = new URLSearchParams(location?.search);
  const activeTab = props?.active ?? urlParams.get("active");

  return (
    <>
      <Box
        sx={{
          backgroundColor: "#F1F7FA",
          padding: {
            xs: "6px 15px",
            sm: "6px 20px",
            md: "6px 20px",
            lg: "6px 30px",
          },
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          gap: "8px",
          zIndex: 99999,
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-start",
            alignItems: "center",
            cursor: "pointer",
          }}
          onClick={() => navigate("/dashboard")}
        >
          {userId ? (
            <Box
              component="img"
              src={EchoIcon}
              alt="logo"
              sx={{
                width: 120,
              }}
            />
          ) : (
            <Box
              component="img"
              src="/images/elevateaviation-logo.png"
              alt="logo"
              sx={{
                width: {
                  xs: "90px",
                  sm: "150px",
                  md: "150px",
                  lg: 200,
                  xl: "271px",
                },
              }}
            />
          )}
        </Box>
        <Box
          sx={{
            flexDirection: "row",
            alignItems: "center",
            display: "flex",
            width: {
              xs: "auto",
              sm: "100%",
              md: "100%",
              lg: "auto",
            },
          }}
        >
          <Box
            mr={2}
            //className="search-bar-div"
            sx={{
              cursor: "pointer",
              position: "relative",
              display: "flex",
              alignItems: "center",
              border: "1px solid #AAB6C8", // Optional border styling
              borderRadius: "50px", // Rounded corners
              padding: "0 15px", // Padding for inner elements
              width: {
                xs: "100%",
                sm: "100%",
                md: "100%",
                lg: "25%",
              }, // Full-width container
              maxWidth: "400px", // Optional max width
              backgroundColor: "white", // Background color
            }}
          >
            {/* Search Icon (Left Side) */}
            <Box
              component="img"
              src="/images/icons/search-icon.png"
              alt="search icon"
              sx={{
                width: {
                  xs: "15px",
                  sm: "20px",
                },
                height: {
                  xs: "15px",
                  sm: "20px",
                },
                marginRight: {
                  xs: "5px",
                  sm: "10px",
                },
                position: "relative",
                top: "-1px",
              }}
            />
            {/* Input Field (Middle) */}
            <form autoComplete="off" onSubmit={(e) => e.preventDefault()}>
              <TextField
                autoComplete="off"
                placeholder="Search"
                value={props.searchTerm}
                onChange={(e) => props.handleSearchChange(e)}
                sx={{
                  "& .MuiInputBase-input": {
                    color: "#2A4876",
                    width: "100%",
                    border: "none", // Remove border
                    outline: "none", // Remove focus outline
                    fontSize: "16px",
                    padding: "8px 0", // Vertical padding
                    backgroundColor: "transparent", // Transparent background
                    textAlign: "left", // Ensure text aligns properly
                    cursor: "pointer",
                  },
                  "& .MuiOutlinedInput-notchedOutline": {
                    border: "0 !important",
                    borderRadius: 0,
                    outline: "none !important",
                  },
                }}
              />
            </form>
            <Box>
              {/* Remove Icon (Right Side) */}
              {props.searchTerm?.length > 0 && (
                <Box
                  onClick={() =>
                    props.handleSearchChange({
                      target: {
                        value: "",
                      },
                    })
                  }
                  component="img"
                  src={RemoveIcon}
                  alt="remove icon"
                />
              )}
            </Box>{" "}
          </Box>
          {role && role != "sponsor" && (
            <Box mr={2}>
              <Button
                onClick={() => setOpenModal(true)}
                sx={{
                  borderRadius: "100px",
                  height: {
                    xs: "40px",
                    sm: "40px",
                    md: "45px",
                    lg: "50px",
                    xl: "60px",
                  },
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  textTransform: "capitalize",
                  padding: {
                    xs: "10px",
                    sm: "10px",
                    md: "10px",
                    lg: "10px 20px",
                    xl: "10px 30px",
                  },
                  color: "#2A4876",
                  fontSize: {
                    xs: "12px",
                    sm: "12px",
                    md: "12px",
                    lg: "16px",
                    xl: "18px",
                  },
                  lineHeight: "23.29px",
                  "&:hover": {
                    background: "#2A48761A",
                    color: "#2A4876",
                    fontWeight: 600,
                  },
                }}
              >
                {getConnectLabel(role)}
              </Button>
            </Box>
          )}
          <Box
            sx={{
              display: {
                xs: "none",
                sm: "none",
                md: "flex",
                lg: "flex",
              },
            }}
          >
            {role && NavItems(role, activeTab)}
          </Box>
          <ProfileDropdown />
        </Box>
        <DashboardHeaderMobile />
      </Box>
      <ConnectButtonModal
        open={openModal}
        onClose={() => setOpenModal(false)}
      />
    </>
  );
};

export default MenteeHeader;
